import React from 'react';

import * as S from './styles';

import { Progress } from '@useblu/ocean-react';

interface IProps {
  isOpen: boolean;
  close?: () => void;
}

const ModalLoading: React.FC<IProps> = ({ isOpen, close }) => {
  return (
    <S.CustomModal isOpen={isOpen} onRequestClose={close} ariaHideApp={false}>
      <Progress size="lg" />
      <S.ModalTitle>Redirecionando para a autenticação bancária</S.ModalTitle>

      <S.ModalSubtitle>Aguarde um instante....</S.ModalSubtitle>
    </S.CustomModal>
  );
};

export default ModalLoading;
